import { createContext, useContext } from 'react'
import { Typography } from '@mui/material'
import { ITourContext } from './types'
import { toLocale } from '$helper/functions/text'

export const defaultValue: ITourContext = {
  stepNumbersOfLabel: '/',
  getStepNumber(
    stepIndex: number,
    stepsCount: number,
    stepNumbersOfLabel: string,
  ) {
    return (
      <>
        {toLocale(stepsCount, false)}
        <Typography
          variant="inherit"
          component="span"
          color="neutral500"
          sx={{ mx: '2px' }}
        >
          {stepNumbersOfLabel}
        </Typography>
        {toLocale(stepIndex, false)}
      </>
    )
  },
}

export const TourContext = createContext<ITourContext>(defaultValue)

export function useTourContext() {
  return useContext(TourContext)
}
